<div *ngIf="isLoading" class="loader-height">
	<div *cygovLoader="isLoading"></div>
</div>

<div class="multi-risk-container" *ngIf="!isLoading">
	<div class="layout">
		<!-- ************************************* Main Header ************************************ -->
		<div class="header">
			<div class="lato-16-n-vw uppercase header-name">
				add new framework
			</div>
			<div class="cross-btn" cygovSvgIcon [svgName]="'x-icon-type2'"
				(click)="closeModal.emit(null)">
			</div>
		</div>
		<!-- ************************************** Main Body Started From Here ************************* -->
		<div class="content">
			<!-- ***** Standard Risk Frameworks Cards + Level Selection Area ******* -->
			<div class="left-section">
				<div class="framework-wrapper lato-16-n-vw">
					<div class="framework-manager-header">
						Choose Vendors Framework
					</div>

					<div class="framework-content lato-14-n-vw">
						<div class="search">
							<div class="search-icon" cygovSvgIcon [svgName]="'search-icon'"></div>
							<input type="text" class="form-control search-input" aria-label="Search"
								placeholder="Search" spellcheck="true" name="search-framework"
								id="search-framework" (keyup)="applyFrameworkSearch()"
								[(ngModel)]="searchFrameworkText" />
						</div>

						<!-- ********* Framework Selection ********-->
						<div class="framework-selection-tabs">
							<ng-container *ngFor="let risk of filteredRiskList; let i=index;">
								<div *ngIf="risk" class="risk-container lato-14-n-vw"
									(click)="onFrameworkSelection(risk)"
									[ngClass]="{'selected-container': risk?.name === selectedRisk?.name, 'already-selected': risk?.alreadySelected}">
									<div class="framework-name-text text-ellipsis">
										{{risk?.name}}
									</div>
								</div>
							</ng-container>
						</div>

						<div class="line-separator"></div>

						<!-- ************ Level Selection **********-->
						<div class="level-section">
							<div class="lato-16-n-vw level-header">
								Level
							</div>
							<div class="level-option-listings">
								<div class="round-checkbox"
									*ngFor="let level of levelOptions;let idz=index">
									<input [id]="'label-' + level" type="radio" [name]="'label'"
										[value]="level" #surveyRadio class="jarl-radio"
										[checked]="level === selectedLevel"
										(click)="selectLevel(level)" />
									<label [for]="'label-' + level"
										class="lato-14-n-vw label target">{{level}}</label>
								</div>
							</div>
						</div>

						<div *ngIf="!sectionsCompletion[0]"
							class="absolute-button next lato-14-n-vw"
							(click)="onSectionCompletion(0)">
							Next</div>
						<div *ngIf="sectionsCompletion[0]" class="absolute-button tick-container">
							<div class="tick" cygovSvgIcon [svgName]="'right-tick'"></div>
						</div>
					</div>
				</div>

				<!-- ********* Artifact Suggested Selection Area Started Here ***********-->
				<div class="artifact-wrapper"
					[ngClass]="{'low-opacity-content': !sectionsCompletion[0]}">
					<div class="lato-16-n-vw artifact-header">
						Question Settings | Artifacts
					</div>
					<div class="artifact-option-listings">
						<div class="round-checkbox"
							*ngFor="let artifact of artifactsOptions;let idz=index">
							<input [id]="'artifact-' + artifact" type="radio" [name]="'artifact'"
								[value]="artifact" #surveyRadio class="jarl-radio"
								[checked]="artifact === selectedArtifact"
								(click)="selectArtifact(artifact)" />
							<label [for]="'artifact-' + artifact"
								class="lato-14-n-vw label target">{{artifact}}</label>
						</div>
					</div>
					<div *ngIf="!sectionsCompletion[1]" class="absolute-button next lato-14-n-vw"
						(click)="onSectionCompletion(1)">
						Next</div>
					<div *ngIf="sectionsCompletion[1]" class="absolute-button tick-container">
						<div class="tick" cygovSvgIcon [svgName]="'right-tick'"></div>
					</div>
				</div>
			</div>
			<!-- ******* Framework Manager + Calendar Selection Area ********* -->
			<div class="right-section">
				<!-- ******  Manager Selection View Mode ***********-->
				<div class="select-manager back-color-default lato-16-n-vw" *ngIf="!editManager"
					[ngClass]="{'low-opacity-content': !sectionsCompletion[1]}">
					<div class="manager-section-header">
						<div class="display-flex">
							<span class="lato-16-n-vw title">The internal project manager that is
								assigned to this
								framework :</span>
							<div id="edit-manager" class="name-with-edit-button"
								(click)="editManager = !editManager">
								<span class="lato-16-n-vw name">{{selectedUser?.name}}</span>
								<div class="edit-icon" cygovSvgIcon [svgName]="'edit-icon'"></div>
							</div>
							<div *ngIf="!sectionsCompletion[2]"
								class="absolute-button next lato-14-n-vw"
								(click)="onSectionCompletion(2)">
								Next</div>
							<div *ngIf="sectionsCompletion[2]"
								class="absolute-button tick-container">
								<div class="tick" cygovSvgIcon [svgName]="'right-tick'"></div>
							</div>
						</div>
					</div>
				</div>
				<!-- ******** Manager Selection Edit Mode ************** -->
				<div class="select-manager-expanded" *ngIf="editManager">
					<div class="expanded-header">
						<div class="lato-16-n-vw title">
							Assign Internal Project Manager
						</div>
						<div class="close-manager" cygovSvgIcon [svgName]="'x-icon-type2'"
							(click)="closeManagerSelection()">
						</div>
					</div>
					<ng-container>
						<div class="search search-manager">
							<div class="search-icon" cygovSvgIcon [svgName]="'search-icon'"></div>
							<input type="text" class="form-control search-input" aria-label="Search"
								placeholder="Search" spellcheck="true" name="search-manager"
								id="search-manager" (keyup)="applyManagerSearch()"
								[(ngModel)]="searchManagerText" />
						</div>

						<div class="users-list" id="users-list">
							<div *ngFor="let user of filteredUserList, index as i" class="user-row">
								<cygov-checkbox [isChecked]="user.checked" [id]=" 'user-'+(i+1)"
									(changed)="changeSelectedManager(user)" [width]="1.8"
									[height]="1.8" [useViewPortDimensions]="true">
								</cygov-checkbox>
								<cygov-username-icon [username]="user.name"></cygov-username-icon>
								<div class="lato-14-n-vw">IT | {{user.role}}</div>
							</div>
						</div>
						<div class="add-user">
							<button class="uppercase standard-btn tm-1"
								[ngClass]="{'disable-add': false}"
								(click)="addManager()">Add</button>
						</div>
					</ng-container>
				</div>
				<!-- ****** Calendar Date Selection Area ********* -->
				<div #calendarSection
					class="calendar-section select-dates back-color-default lato-16-n-vw "
					[ngClass]="{'reduce-height': editManager, 'low-opacity-content': !sectionsCompletion[2]}"
					*ngIf="!editManager">
					<div class="section-heading">
						Assessment Duration
					</div>
					<div class="adjust-calendar-margin">
						<cygov-assessment-duration-calendar [startDate]="selectedStartDate"
							[endDate]="selectedEndDate" [disableAll]="1"
							class="section-content start-end-date-calendars"
							(startDateChanged)="startDateChanged($event)"
							(endDateChanged)="endDateChanged($event)">
						</cygov-assessment-duration-calendar>
					</div>
				</div>
				<div class="re-assess-duration-container"
					[ngClass]="{'low-opacity-content': !sectionsCompletion[2]}">
					<div class="re-assess-duration">
						<div class="lato-14-n-vw re-assess-text">
							Re-assess every
						</div>
						<div class="decrementor" cygovSvgIcon [svgName]="'arrow-down-type1'"
							(click)="decrementor()"></div>
						<input type="number" (focusout)="checkDaysValidation()" min="1" max="365"
							[(ngModel)]="frequencyDays" class="lato-14-n-vw frequency-count" />
						<div class="incrementor" cygovSvgIcon [svgName]="'arrow-up-type1'"
							(click)="incrementor()">
						</div>
						<div class="lato-14-n-vw days-text">
							days
						</div>
					</div>
					<div *ngFor="let checker of frequencyOpt;let idc=index" class="check-selection">
						<div class="selection-box">
							<div *ngIf="checker.checked" class="selected-tick" cygovSvgIcon
								[svgName]="'right-tick'"></div>
						</div>
						<div class="lato-14-n-vw txt-white">
							{{checker.name}}
						</div>
					</div>
				</div>

			</div>
		</div>
		<!-- ************************************** Main Footer Started From Here ********************** -->
		<div class="action-buttons">
			<button class="uppercase standard-btn-grey"
				(click)="closeModal.emit(null)">Cancel</button>
			<button class="uppercase standard-btn"
				[ngClass]="{'add-button-disable': !sectionsCompletion[2]}"
				(click)="addFramework()">Add</button>
		</div>
	</div>
</div>